export default __webpack_public_path__ + "static/media/experiencen.233e03f3.svg";